import React, { useEffect, useState } from "react";
import { get } from "lodash";
import { Col, Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import CouponPaymentSchedule from "./CouponPaymentSchedule";
import ShowYTMModal from "./ShowYTMModal";
import { chooseTheme } from "../../constants/themeColor";
import moment from "moment";

export default function InvestmentOverviewMainMob(props) {
  const { Coupons } = props;
  const { realisedCouponsSum } = props;
  const [showFAQ, setShowFAQ] = useState(false);
  const [showAssetTable, setShowAssetTable] = useState(false);
  const [portfolio, setPortfolio] = useState([]);

  useEffect(() => {
    let pf = [];
    if (props.productType !== "bonds") {
      pf = [
        {
          title: "Current Value",
          value: get(props.portfolioValue, "data.pfStats.mtm", 0)
            .oroNumber(2, true),
        },
        {
          title: "Amount Invested",
          value: get(props.portfolioValue, "data.pfStats.userInvestedAmnt", 0).oroNumber(2,true  ) ?
          get(props.portfolioValue, "data.pfStats.userInvestedAmnt", 0).oroNumber(2,true  ) : "--"
        },
        {
          title: "Units",
          value: get(props.portfolioValue, "data.pfStats.units", 0),
        },
        {
          title: "Absolute Returns",
          value:Math.round(
            get(props?.portfolioValue, "data.absoluteReturns", 0) * 100
          ) / 100 + "%"
        },
        {
          title: "Maturity Date",
          value: moment(new Date(props.assetDetails?.maturityDate)).format("Do MMM YYYY"),
        },
      ];
    } else {
      pf = [
        {
          title: "Current Value",
          value: get(props.portfolioValue, "data.pfStats.mtm", 0).oroNumber(2, true),
        },
        {
          title: "Payouts",
          value: Coupons ? Coupons : "",
        },
        {
          title: "Amount Invested",
          value: get(props.portfolioValue, "data.pfStats.userInvestedAmnt", 0).oroNumber(
            2,
            true
          ),
        },
        {
          title: "Units",
          value: get(props.portfolioValue, "data.pfStats.units", 0),
        },
        {
          title: "XIRR",
          value: get(props.portfolioValue, "data.userXirr", "")
        },
      ];
    }
    setPortfolio([...pf]);
  }, [props.portfolioValue, props.productType]);


  const style = {
    maxWidth: "1060px",
    margin: props?.productType === "mld" ? "0 15px" : "-1rem 15px -5rem 15px",
  };
  const container = {
    color: "white",
    background: chooseTheme().secondary,
    borderRadius: "8px",
    margin: "2rem 0.5rem 1rem",
    padding: "1rem",
  };

  const closeFAQModal = () => {
    setShowFAQ(!showFAQ);
  };

  const toggleAssetTable = () => {
    setShowAssetTable(!showAssetTable);
  };

  const redirectToLiquidate = (product, productType) => {
    window.location.href = `/platform/#/biddeasy-asset/${productType}/${product}/redeem`;
  }

  return (
    <>
      <Row
        className="mx-auto align-items-center justify-content-between w-100"
        style={style}
      >
      <Row style={container} className="justify-content-start">
        {portfolio.map((item, index) => (
          <Col className="col-6 p-0 my-3">
            <p className="mb-2" style={{ fontSize: "14px" }}>
              {item.title}{item.title === 'Current Value'
                ? <span onClick={() => setShowFAQ(true)}
                  style={{
                    cursor: "pointer",
                    fontSize: "15px"
                  }}
                  className="mdi mdi-information-outline ml-1"
                />
                : item.title === 'Payouts'
                  ?
                  <p
                    style={{
                      cursor: 'pointer',
                      fontSize: "9px",
                      textDecoration: 'underline',
                      display: 'inline-block',
                      marginBottom: '0',
                      marginLeft: '5px',
                      color: "#FFFFFF",
                      fontWeight: "600"
                    }}
                    onClick={toggleAssetTable}
                  >
                    Show More
                  </p>
                  : item.title === "Units" && props?.isRedemptionAllowed ?
                  <p
                    style={{
                      cursor: 'pointer',
                      fontSize: "9px",
                      textDecoration: 'underline',
                      display: 'inline-block',
                      marginBottom: '0',
                      marginLeft: '5px',
                      color: "#FFFFFF",
                      fontWeight: "600"
                    }}
                    onClick={() => redirectToLiquidate(props?.productName, props?.productType)}
                  >
                    Liquidate Now
                  </p>
                  : null
              }
            </p>
            <p
              className="mb-2 font-weight-semi-bold"
              style={{ fontSize: "16px" }}
            >
              {item.title === "XIRR" ? item.value ?
                item.value + "% p.a." : "NA" : item.title === "Payouts" ?
                realisedCouponsSum ? (realisedCouponsSum).oroNumber(2, true) : "₹ 0" : item.value}
            </p>
          </Col>
        ))}
      </Row>
    </Row >

    <CouponPaymentSchedule
      showAssetTable={showAssetTable}
      toggleAssetTable={toggleAssetTable}
      Coupons={Coupons}
      realisedCouponsSum={realisedCouponsSum}
    />

      <Modal
        centered
        isOpen={showFAQ}
        toggle={closeFAQModal}
        className="modal-md"
      >
        <ModalHeader toggle={closeFAQModal} className="pt-3"></ModalHeader>
        <ModalBody className="text-center p-3">
        <div className="mt-2 mb-4" style={{ textAlign: "left" }}>
            <b className="font-size-12">
            Current Value is the multiplication of per unit current price of asset 
            (dirty price) and number of units held by investors. 
            </b>
        </div>
          {/* <Button className="mt-4 done-button" onClick={closeFAQModal}>
            Close
          </Button> */}
        </ModalBody>
      </Modal>
  {
    props.showYTM &&
      <ShowYTMModal
        closeYTMModal={props.closeYTMModal}
        showYTM={props.showYTM}
        currYield={props.currYield}
      />
  }
    </>
  );
}
